<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <IntallInstructionsForm
        v-if="installInstructions"
        :installInstruction="installInstructions"
      />
      <LoadingPage v-if="!installInstructions" />
    </PageRowWrapper>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import IntallInstructionsForm from "@/components/settings/integrador/install-instructions/InstallInstructionsForm";
import LoadingPage from "@/components/spinner/LoadingPage";

export default {
  name: "InstallInstructionsEditView",
  components: {
    PageTitle,
    PageRowWrapper,
    IntallInstructionsForm,
    LoadingPage,
  },

  computed: {
    ...mapState({
      installInstructions: (state) => state.integrator.installInstructionsById,
    }),
  },

  mounted() {
    this.$store.dispatch(
      "integrator/fetchIntegratorInstallInstructionsById",
      this.$route.params.id
    );
  },
};
</script>
